"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const TravelDatesMobileModalWrapper = (0, styled_components_1.default)(components_common_modals_1.WhiteBoxModal).attrs({
    name: 'travelDates',
    fullScreen: true,
})({
    '.modal-body': {
        overflowY: 'hidden',
    },
});
const MobileModal = ({ children, label, title, show, className, closeModal, }) => {
    return (react_1.default.createElement(TravelDatesMobileModalWrapper, { label: label, title: title, show: show, onClose: closeModal, className: className }, children));
};
exports.default = MobileModal;
//# sourceMappingURL=mobile-modal.js.map